import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareCursor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareCursor"><Path d="M3 3H21V11H19V5H5V19H11V21H3V3Z" fill="currentColor"/><Path d="M23.4554 14.1439L10.5625 10.5625L14.1439 23.4554L17.7252 17.7252L23.4554 14.1439Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareCursor;
